import { createInjectionKey } from "../../_utils/index.mjs";
export const colorPickerInjectionKey = createInjectionKey('n-color-picker');